// @flow

/**
 * @module Constants/Prospect
 * @desc Prospect Constants
 */

import keyMirror from 'fbjs/lib/keyMirror';

/**
  * @constant {Object} ProspectConstants
  * @memberof Prospect
  */
export const ProspectConstants = keyMirror({
  PROSPECT_IMPORT_APPLICATIONS: undefined,
  PROSPECT_IMPORT_APPLICATION_ID: undefined,
});



// WEBPACK FOOTER //
// ./src/constants/prospect.js